import constants from '../constants/common';

const { MENU_ITEMS, STATUSES } = constants;

function isOnlyRuItem(item) {
  const ruMenuItems = [MENU_ITEMS.travelexpert, MENU_ITEMS.achievements, MENU_ITEMS.virtualcard];

  return ruMenuItems.some((onlyRuItem) => onlyRuItem === item);
}

function isPremiumItem(item) {
  return [MENU_ITEMS.travelexpert].some((onlyRuItem) => onlyRuItem === item);
}

function isOnlyOTTItem(item) {
  return [
    MENU_ITEMS.travelexpert,
    MENU_ITEMS.achievements,
    MENU_ITEMS.virtualcard,
    // TODO add other dropdown and menu items
    // that should not be displayed in the
    // OTT + Brand scenario
  ].some((onlyOTTItem) => onlyOTTItem === item);
}

export const filterItem = (filterData) => (item) => {
  const { isAuthenticated, userStatus, partner, lang } = filterData;

  if (Boolean(partner) && isOnlyOTTItem(item)) {
    return false;
  }

  if (isAuthenticated) {
    if (lang !== 'ru' && isOnlyRuItem(item)) {
      // Remove achievements and travelexpert items for non-ru locales
      return false;
    }

    if (userStatus !== STATUSES.premium && isPremiumItem(item)) {
      // Remove travelexpert item for non-premium customers
      return false;
    }
  }

  return true;
};

/**
 * This function filters predefined itemsct
 * @name filterItems
 * @function
 * @param items Array of items
 * @param filterData Filter data containing auth and lang data
 * @returns {Array}
 */
export default (items, filterData) => {
  if (!filterData || !filterData.auth) {
    return items;
  }

  return items.filter(filterItem());
};
